/** Shape shared by both a full group (`GroupDetail`) and a lightweight group listing row (`GroupSummary`). */
interface LabelableGroup {
  type?: string | null;
  title?: string | null;
}

/** Display label for a group: its title, or a fallback derived from its type (e.g. "Email group"). */
export function formatGroupLabel(group: LabelableGroup): string {
  if (group.title) return group.title;
  if (group.type) return `${group.type.charAt(0).toUpperCase()}${group.type.slice(1)} group`;
  return 'Group';
}
